export default __webpack_public_path__ + "static/media/The-cast-of-Les-Miserables.c3cb1daa.jpg";